import { connect } from 'react-redux'

import { 
    Paginacion,
    selectors
} from 'ibook-api'

const mapStateToProps = (state, ownProps) => {
    const numPagina = selectors.getNumPaginaIzquierda(state, ownProps.libroId, ownProps.numPagina)
    const incremento = 2   
    const separador = selectors.getConfigGeneral(state).separadorPaginacion || ' of '
    return {        
        primeraPagina: selectors.getPrimeraPagina(state, ownProps.libroId),
        ultimaPagina: selectors.getUltimaPagina(state, ownProps.libroId),
        incremento,
        numPagina,
        separador
    }
}

const PaginacionContainer = connect(
    mapStateToProps,
    null
)(Paginacion)

export default PaginacionContainer